import { fromUTCtoZoneFormatted } from 'Helpers/dates'

import {
  beSendGoApiGetSmartPlanningSuggestedDate,
  beSendGoDeleteSending,
  beSendGoExchangeOrderReadySending,
  beSendGoGetEmailSendingDetails,
  beSendGoGetNoDisturbConfig,
  beSendGoGetReadySending,
  beSendGoGetRunningSending,
  beSendGoGetStandBySending,
  beSendGoRecoverSending,
  beSendGoRemoveNoDisturbConfig,
  beSendGoSetNoDisturbConfig,
  beSendGoSetStandBySendingToReady,
  beSendGoStopSending,
  beSendGoUpdateNoDisturbConfig
} from 'Api/beSendGoApi'

import { BeListApiGetList, beListGetUserVisibleLists } from 'Api/BeListApi'

import {
  beMessGetDynamicContentByIdMessages,
  beMessMessagesDetailByIds
} from 'Api/BeMessApi'

import {
  BEQUEUE_CONFIG_ACTION_MAIL,
  BEQUEUE_CONFIG_EXCLUDE,
  BEQUEUE_CONFIG_FILTER_COND_OR,
  BEQUEUE_CONFIG_INCLUDE,
  BEQUEUE_CONFIG_TYPE_EVERYBODY,
  beQueueCancelConfigurationProcessing,
  beQueueExecuteConfigurationProcessing,
  beQueueGetRetryConfiguration,
  beQueueSimulateConfigurationProcessing
} from 'Api/beQueueApi'

import { bePecPlusGetListOfPecPlusConfigs } from 'Api/bePecPlusApi'

import {
  ABTEST_STATUS_ENQUEUING,
  ABTEST_STATUS_ERROR,
  ABTEST_STATUS_POST_ENQUEUING,
  ABTEST_STATUS_PRE_ENQUEUING,
  ABTEST_STATUS_SCHEDULING,
  ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_COMPLETED,
  ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_STARTED,
  ABTEST_STATUS_SENDING_OF_WINNER_MESSAGE_STARTED,
  ABTEST_STATUS_WAITING_FOR_SENDING_OF_TEST_MESSAGES,
  ABTEST_STATUS_WINNER_MESSAGE_DEFINED,
  beABTestGetABTestConfigById,
  beABTestGetAbTestIdByInvio
} from 'Api/beABTestApi'

import {
  CAMPAIGN_CHANNEL_TYPE_EMAIL,
  campaignsBuilderGetEmailCampaignByIdMessage
} from 'Api/campaignsBuilderApi'

import { beRecipientGetGroupDetails } from 'Api/beRecipientApi'

import { beFiltersGetFilter, FILTER_TYPE_ENGAGEMENT } from 'Api/beFiltersApi'

import {
  MESSAGE_STR_TYPE_CONTENTSCAMPAIGN,
  PECPLUS_STATUS_COMPLETE,
  SENDING_ABTEST_STATUS_ERROR,
  SENDING_ABTEST_STATUS_QUEUE_COMPLETED,
  SENDING_ABTEST_STATUS_QUEUE_RUNNING,
  SENDING_ABTEST_STATUS_TESTS_COMPLETED,
  SENDING_ABTEST_STATUS_WAITING_TESTS,
  SENDING_ABTEST_STATUS_WINNER_MESSAGE_STARTED,
  SENDING_ABTEST_STATUS_WINNER_READY_TO_SEND,
  SENDING_SOURCE_ABTEST_TEST,
  SENDING_SOURCE_ABTEST_WINNER,
  SENDING_SOURCE_CAMPAIGN,
  SENDING_SOURCE_IMMEDIATE,
  SENDING_SOURCE_SCHEDULED,
  SENDING_SOURCE_SCHEDULED_NOW,
  SENDING_STATUS_ABORTED,
  SENDING_STATUS_ENDING,
  SENDING_STATUS_FAILED,
  SENDING_STATUS_QUEUECANCELLED,
  SENDING_STATUS_QUEUECOMPLETED,
  SENDING_STATUS_QUEUEFAILED,
  SENDING_STATUS_QUEUETOEXECUTED,
  SENDING_STATUS_RETRY_SENDING,
  SENDING_STATUS_RUNNING,
  SENDING_STATUS_STOPPING,
  STORE_KEY_ACCOUNT,
  STORE_KEY_USER,
  STORE_KEY_USER_LISTS
} from 'Constants'

import { storeGet } from 'Helpers/localStorage'

import { SENDING_STATUS_NOT_DISTURB, STORE_KEY_ID_LIST } from 'Constants/index'
import evalCondition from 'Helpers/evalCondition'
import getIntl from 'Helpers/intl'
import { getLang } from 'mailup-react-helpers'

export const fetchUserLists = () => {
  return beListGetUserVisibleLists(storeGet(STORE_KEY_USER).Id)
}

const isABTest = source =>
  [SENDING_SOURCE_ABTEST_WINNER, SENDING_SOURCE_ABTEST_TEST].includes(source)

const getABTestSendingStatus = ABTestStatus => {
  switch (ABTestStatus) {
    case ABTEST_STATUS_ERROR:
      return SENDING_ABTEST_STATUS_ERROR

    case ABTEST_STATUS_PRE_ENQUEUING:
    case ABTEST_STATUS_ENQUEUING:
    case ABTEST_STATUS_POST_ENQUEUING:
      return SENDING_ABTEST_STATUS_QUEUE_RUNNING

    case ABTEST_STATUS_SCHEDULING:
      return SENDING_ABTEST_STATUS_QUEUE_COMPLETED

    case ABTEST_STATUS_WAITING_FOR_SENDING_OF_TEST_MESSAGES:
    case ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_STARTED:
      return SENDING_ABTEST_STATUS_WAITING_TESTS

    case ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_COMPLETED:
      return SENDING_ABTEST_STATUS_TESTS_COMPLETED

    case ABTEST_STATUS_WINNER_MESSAGE_DEFINED:
      return SENDING_ABTEST_STATUS_WINNER_READY_TO_SEND

    case ABTEST_STATUS_SENDING_OF_WINNER_MESSAGE_STARTED:
      return SENDING_ABTEST_STATUS_WINNER_MESSAGE_STARTED
  }
}

/**
 * @param {{Id: Number, Source: String}[]} items
 * @returns {Map} map of Id sending: ABTest config
 */
export async function getABTestsInfo(items) {
  const abtestSendingsIds = items.filter(o => isABTest(o.Source)).map(o => o.Id)

  const abtestIds = await Promise.all(
    abtestSendingsIds.map(idSending => beABTestGetAbTestIdByInvio(idSending))
  )

  const abtestConfigs = await Promise.all(
    abtestIds.map(idABTest =>
      idABTest !== -1 ? beABTestGetABTestConfigById(idABTest) : undefined
    )
  )

  return abtestConfigs.reduce(
    (map, config, index) =>
      map.set(abtestSendingsIds[index], {
        ABTestID: config ? config.Info.ABTestID : undefined,
        ABTestStatus: config
          ? getABTestSendingStatus(config.Info.Stato)
          : undefined
      }),
    new Map()
  )
}

export async function getCampaignsInfo(items) {
  const messageIds = Array.from(
    new Set(
      items
        .filter(o => o.messageType === MESSAGE_STR_TYPE_CONTENTSCAMPAIGN)
        .map(o => ({
          idMessage: o.idMessage,
          idList: o.idList
        }))
    )
  )

  const campaignCalls = messageIds.map(({ idMessage, idList }) =>
    campaignsBuilderGetEmailCampaignByIdMessage(idMessage, idList)
  )

  const campaigns = await Promise.all(campaignCalls)

  return messageIds.reduce(
    (map, { idMessage }, index) =>
      map.set(idMessage, {
        campaignId: campaigns[index].Id,
        campaignType: CAMPAIGN_CHANNEL_TYPE_EMAIL,
        campaignName: campaigns[index].Name,
        campaignIdSource: campaigns[index].IdSource
      }),
    new Map()
  )
}

export async function getListsTimezones(listIds) {
  const result = await Promise.all(
    listIds.map(idList => BeListApiGetList(idList))
  )

  return result.reduce(
    (acc, { IdList, TimeZoneCode }) => ({ ...acc, [IdList]: TimeZoneCode }),
    {}
  )
}

export async function fetchRunningSending() {
  const { GracePeriod, Bandwidth, IsSendMethodTypeFrequency } = storeGet(
    STORE_KEY_ACCOUNT
  )

  const lang = getLang()

  const userLists = storeGet(STORE_KEY_USER_LISTS)

  const results = await beSendGoGetRunningSending()

  const messageIds = results.Items.map(o => o.IdMessage)
  const allMessagesDetails =
    messageIds.length > 0
      ? await beMessMessagesDetailByIds(messageIds, true)
      : []
  const allMessagesDC =
    messageIds.length > 0
      ? await beMessGetDynamicContentByIdMessages(messageIds)
      : []

  const HasHidden =
    results.Items.filter(o => !userLists.includes(o.IdList)).length > 0

  const HasImmediateHidden =
    results.Items.filter(
      o =>
        !userLists.includes(o.IdList) && o.Source === SENDING_SOURCE_IMMEDIATE
    ).length > 0

  const ToSend = results.Items.reduce((acc, v) => acc + (v.Queued - v.Sent), 0)

  const TotBytes = results.Items.reduce((totBitesAcc, sendingItem) => {
    const toSend = sendingItem.Queued - sendingItem.Sent
    const { Size: messageSize } = allMessagesDetails.find(
      o => o.Id === sendingItem.IdMessage
    )
    const dcInfo = allMessagesDC.Items.find(
      o => o.IdMessage === sendingItem.IdMessage
    )
    const dcSize = dcInfo
      ? dcInfo.Contents.reduce((acc, v) => acc + v.Size, 0)
      : 0

    return totBitesAcc + (messageSize + dcSize) * toSend
  }, 0)

  const TotalSendTime = Math.ceil(
    IsSendMethodTypeFrequency
      ? (60 * ToSend) / Bandwidth
      : TotBytes / 1024 / Bandwidth
  )

  const tmpItems = results.Items.filter(o => userLists.includes(o.IdList))

  const ABTestInfoMap = await getABTestsInfo(tmpItems)

  const listsIds = Array.from(new Set(tmpItems.map(({ IdList }) => IdList)))
  const listsTimezones = await getListsTimezones(listsIds)

  /*

     int idAbTest = 0;
                        if (sendingItem.Source == SendingSource.ABTestTest || sendingItem.Source == SendingSource.ABTestWinner)
                        {

                            idAbTest = abTestBiz.GetABTestIdByIdInvio(sendingItem.IdInvio);
                            if (idAbTest > 0)
                            {
                                ABTestConfigResponseDto configResponseDto = abTestBiz.GetABTestConfig(idAbTest);

                                sendingItem.ABTestStatus = GetABTestStatus(configResponseDto);
                                sendingItem.ABTestId = idAbTest;
                            }
                        }

                        if (sendingItem.MessageType == EmailMessageType.ContentsCampaign)
                        {

                            var campaignData = campaignsBiz.GetCampaignByIdMessage(sendingItem.IdList, sendingItem.IdNL);
                            sendingItem.CampaignEmailData = campaignData;
                            sendingItem.SubjectNL = campaignData.Name;
                        }

    */

  //  beMessListMessagesByIds

  const canStop = evalCondition('uo:GEST OR NOT uo:NOSTOPSENDING')

  const Items = tmpItems.map(o => {
    const message = allMessagesDetails.find(m => m.Id === o.IdMessage)

    const stopRunning =
      o.Source !== SENDING_SOURCE_ABTEST_WINNER &&
      o.Source !== SENDING_SOURCE_ABTEST_TEST &&
      canStop &&
      (o.Status === SENDING_STATUS_RUNNING ||
        o.Status === SENDING_STATUS_RETRY_SENDING ||
        o.Status === SENDING_STATUS_NOT_DISTURB) &&
      GracePeriod !== 2

    const recover =
      o.Source !== SENDING_SOURCE_ABTEST_WINNER &&
      o.Source !== SENDING_SOURCE_ABTEST_TEST &&
      (o.Status === SENDING_STATUS_ABORTED ||
        o.Status === SENDING_STATUS_FAILED) &&
      GracePeriod !== 2

    const manageABTest =
      o.Source === SENDING_SOURCE_ABTEST_WINNER ||
      o.Source === SENDING_SOURCE_ABTEST_TEST

    const startingUp =
      !o.Started &&
      o.Status !== SENDING_STATUS_ENDING &&
      o.Status !== SENDING_STATUS_STOPPING

    const itemTimezone = o.TimeZoneInternalCode
      ? o.TimeZoneInternalCode
      : listsTimezones[o.IdList]

    return {
      idSending: o.Id,
      source: o.Source,
      status: o.Status,
      title: message.Subject,
      idMessage: o.IdMessage,
      note: message.Note,
      sender: o.SenderNl,
      idList: o.IdList,
      isPartial: o.IsPartial,
      dateFormatted: o.StartDate
        ? fromUTCtoZoneFormatted(
            o.StartDate,
            itemTimezone,
            'YYYY-MM-DD ddd HH:mm UTCZ',
            lang
          )
        : undefined,
      progress: o.Queued ? o.Sent / o.Queued : undefined,
      sent: o.Sent,
      total: o.Queued,
      retryCounter: o.RetryCounter,
      messageType: message.MessageType,
      started: o.Started,
      ...ABTestInfoMap.get(o.Id),
      startingUp,
      actions: {
        stopRunning:
          stopRunning &&
          message.MessageType !== MESSAGE_STR_TYPE_CONTENTSCAMPAIGN,
        stopRunningCampaign:
          stopRunning &&
          message.MessageType === MESSAGE_STR_TYPE_CONTENTSCAMPAIGN,
        recover,
        manageABTest
      }
    }
  })

  const ImmediateRunningSendings = Items.filter(
    o =>
      o.Status === SENDING_STATUS_RUNNING &&
      o.Source === SENDING_SOURCE_IMMEDIATE
  )

  const campaignsMapping = await getCampaignsInfo(Items)

  const withCampaignsData = Items.map(o => {
    const campaignData = campaignsMapping.get(o.idMessage)
    return {
      ...o,
      ...campaignData,
      title: campaignData ? campaignData.campaignName : o.title
    }
  })

  return {
    HasHidden,
    HasImmediateHidden,
    ToSend,
    TotBytes,
    TotalSendTime,
    Items: withCampaignsData,
    ImmediateRunningSendings
  }
}

/**
 * @description sorting function for list of ready sendings. put on top SENDING_SOURCE_IMMEDIATE ordered by Order, then ordered by StartDateUTC
 *
 *
 */
export const sortReadySending = (a, b) => {
  const immediateSorting =
    a.Source === SENDING_SOURCE_IMMEDIATE &&
    b.Source === SENDING_SOURCE_IMMEDIATE
      ? a.Order - b.Order
      : 0

  return immediateSorting > 0
    ? immediateSorting
    : a.Source === SENDING_SOURCE_IMMEDIATE
    ? -1
    : b.Source === SENDING_SOURCE_IMMEDIATE
    ? 1
    : `${a.StartDateUTC}`.localeCompare(b.StartDateUTC)
}

export async function fetchReadySending() {
  const lang = getLang()
  const now = new Date()
  const canSend = evalCondition('NOT uo:NOSEND')
  const canStop = evalCondition('uo:GEST OR NOT uo:NOSTOPSENDING')
  const canSchedule = evalCondition('NOT uo:NOSEND AND NOT uo:NOSCHED')
  const selectedRecipients = true
  const { GracePeriod } = storeGet(STORE_KEY_ACCOUNT)
  const userLists = storeGet(STORE_KEY_USER_LISTS)

  const results = await beSendGoGetReadySending()

  const messageIds = results.Items.map(o => o.IdMessage)

  const allMessagesDetails =
    messageIds.length > 0
      ? await beMessMessagesDetailByIds(messageIds, true)
      : []

  const HasImmediateHidden =
    results.Items.filter(
      o =>
        !userLists.includes(o.IdList) && o.Source === SENDING_SOURCE_IMMEDIATE
    ).length > 0

  const tmpItems = results.Items.filter(o => userLists.includes(o.IdList)).sort(
    sortReadySending
  )

  const ABTestInfoMap = await getABTestsInfo(tmpItems)

  const ImmediateSendings = tmpItems
    .filter(o => o.Source === SENDING_SOURCE_IMMEDIATE)
    .sort((a, b) => a.Order - b.Order)
    .map(o => o.Id)

  const Items = tmpItems.map(o => {
    const message = allMessagesDetails.find(m => m.Id === o.IdMessage)

    const nextToRunning = new Date(o.StartDateUTC).getTime() - now < 60000

    //
    const stopScheduled =
      o.Source !== SENDING_SOURCE_ABTEST_WINNER &&
      o.Source !== SENDING_SOURCE_ABTEST_TEST &&
      (canStop ||
        (o.source !== SENDING_SOURCE_IMMEDIATE &&
          o.source !== SENDING_SOURCE_SCHEDULED_NOW)) &&
      GracePeriod !== 2

    const modifySchedule =
      o.Source !== SENDING_SOURCE_ABTEST_WINNER &&
      o.Source !== SENDING_SOURCE_ABTEST_TEST &&
      canSchedule &&
      o.Source === SENDING_SOURCE_SCHEDULED &&
      !nextToRunning &&
      GracePeriod !== 2

    const manageABTest =
      o.Source === SENDING_SOURCE_ABTEST_WINNER ||
      o.Source === SENDING_SOURCE_ABTEST_TEST

    const moveUp =
      o.Source === SENDING_SOURCE_IMMEDIATE &&
      canSend &&
      GracePeriod !== 2 &&
      o.Id !== ImmediateSendings[0]

    const moveDown =
      o.Source === SENDING_SOURCE_IMMEDIATE &&
      canSend &&
      GracePeriod !== 2 &&
      o.Id !== ImmediateSendings[ImmediateSendings.length - 1]

    const fasciaDiNonDisturbo =
      o.Source !== SENDING_SOURCE_ABTEST_WINNER &&
      o.Source !== SENDING_SOURCE_ABTEST_TEST &&
      canSchedule &&
      o.Source === SENDING_SOURCE_SCHEDULED &&
      !nextToRunning &&
      GracePeriod !== 2

    return {
      idSending: o.Id,
      source: o.Source,
      status: o.Status,
      planningType: o.PlanningType,
      title: message.Subject,
      idMessage: o.IdMessage,
      note: message.Note,
      sender: o.SenderNl,
      idList: o.IdList,
      isPartial: o.IsPartial,
      timeZoneCode: o.TimeZoneInternalCode,
      dateFormatted: o.StartDateUTC
        ? fromUTCtoZoneFormatted(
            o.StartDateUTC,
            o.TimeZoneInternalCode,
            'YYYY-MM-DD ddd HH:mm UTCZ',
            lang
          )
        : undefined,
      date: o.StartDateUTC,
      scheduled: true,
      order: o.Order,
      sent: o.Sent,
      total: o.Queued,
      nextToRunning,
      messageType: message.MessageType,
      ...ABTestInfoMap.get(o.Id),
      actions: {
        stopScheduled:
          stopScheduled &&
          message.MessageType !== MESSAGE_STR_TYPE_CONTENTSCAMPAIGN,
        stopScheduledCampaign:
          stopScheduled &&
          message.MessageType === MESSAGE_STR_TYPE_CONTENTSCAMPAIGN,
        modifySchedule,
        manageABTest,
        fasciaDiNonDisturbo,
        selectedRecipients,
        moveUp,
        moveDown
      }
    }
  })

  const campaignsMapping = await getCampaignsInfo(Items)

  const withCampaignsData = Items.map(o => {
    const campaignData = campaignsMapping.get(o.idMessage)
    return {
      ...o,
      ...campaignData,
      title: campaignData ? campaignData.campaignName : o.title
    }
  })

  return {
    Items: withCampaignsData,
    ImmediateSendings,
    HasImmediateHidden
  }
}

export async function fetchStandBySending() {
  const canScheduleNow = evalCondition(
    'NOT uo:NOSCHED AND NOT uo:NOIMMEDIATESEND AND NOT uo:NOSEND'
  )
  const canSchedule = evalCondition(
    '(NOT uo:NOIMMEDIATESEND OR NOT uo:NOSCHED) AND NOT uo:NOSEND'
  )
  const canEdit = evalCondition('NOT uo:NONL')
  const canEditBee = evalCondition('uo:BEEEDITORENABLE')
  const canCheckUp = evalCondition('uo:CHECKUP')
  const selectedRecipients = true

  const { GracePeriod } = storeGet(STORE_KEY_ACCOUNT)

  const results = await beSendGoGetStandBySending()
  const messageIds = results.Items.map(o => o.IdMessage)
  const allMessagesDetails =
    messageIds.length > 0
      ? await beMessMessagesDetailByIds(messageIds, true)
      : []

  const pecPlusConfigs = await bePecPlusGetListOfPecPlusConfigs([], 0, 0)
  const userLists = storeGet(STORE_KEY_USER_LISTS)

  //  console.table(results.Items)

  const pecPlusConfigsNotCompleted = pecPlusConfigs.Items.filter(
    p => p.Status !== PECPLUS_STATUS_COMPLETE
  )

  const tmpItems = results.Items.filter(
    o =>
      o.Source !== SENDING_SOURCE_ABTEST_TEST &&
      o.Source !== SENDING_SOURCE_ABTEST_WINNER
  ).filter(o => userLists.includes(o.IdList))

  const ABTestInfoMap = await getABTestsInfo(tmpItems)

  const Items = tmpItems.map(o => {
    const message = allMessagesDetails.find(m => m.Id === o.IdMessage)

    const scheduleNow =
      o.Source !== SENDING_SOURCE_ABTEST_WINNER &&
      o.Source !== SENDING_SOURCE_ABTEST_TEST &&
      canScheduleNow &&
      o.Queued > 0 &&
      GracePeriod !== 2 &&
      pecPlusConfigsNotCompleted.every(pec => pec.IdList !== o.IdList) &&
      (o.Status === SENDING_STATUS_QUEUECOMPLETED ||
        o.Status === SENDING_STATUS_QUEUEFAILED)

    const schedule =
      o.Source !== SENDING_SOURCE_ABTEST_WINNER &&
      o.Source !== SENDING_SOURCE_ABTEST_TEST &&
      canSchedule &&
      o.Queued > 0 &&
      GracePeriod !== 2 &&
      (o.Status === SENDING_STATUS_QUEUECOMPLETED ||
        o.Status === SENDING_STATUS_QUEUEFAILED)

    const edit =
      o.Source !== SENDING_SOURCE_ABTEST_WINNER &&
      o.Source !== SENDING_SOURCE_ABTEST_TEST &&
      o.Source !== SENDING_SOURCE_CAMPAIGN &&
      canEdit &&
      (!message.IsBee || canEditBee)

    const manageCampaign = o.Source === SENDING_SOURCE_CAMPAIGN

    const checkup =
      o.Source !== SENDING_SOURCE_ABTEST_WINNER &&
      o.Source !== SENDING_SOURCE_ABTEST_TEST &&
      canCheckUp

    const retryCheckQueue =
      o.Source !== SENDING_SOURCE_ABTEST_WINNER &&
      o.Source !== SENDING_SOURCE_ABTEST_TEST &&
      o.Source !== SENDING_SOURCE_CAMPAIGN &&
      (o.Status === SENDING_STATUS_QUEUEFAILED ||
        o.Status === SENDING_STATUS_QUEUECANCELLED)

    const cancelCheckQueue =
      o.Source !== SENDING_SOURCE_ABTEST_WINNER &&
      o.Source !== SENDING_SOURCE_ABTEST_TEST &&
      o.Source !== SENDING_SOURCE_CAMPAIGN &&
      o.Status === SENDING_STATUS_QUEUETOEXECUTED

    const previewQueueComplete =
      o.Source !== SENDING_SOURCE_ABTEST_WINNER &&
      o.Source !== SENDING_SOURCE_ABTEST_TEST &&
      o.Status === SENDING_STATUS_QUEUECOMPLETED &&
      o.Queued > 0

    const previewQueueRunning =
      o.Source !== SENDING_SOURCE_ABTEST_WINNER &&
      o.Source !== SENDING_SOURCE_ABTEST_TEST &&
      o.Source !== SENDING_SOURCE_CAMPAIGN &&
      o.Status !== SENDING_STATUS_QUEUECOMPLETED &&
      o.Status !== SENDING_STATUS_QUEUECANCELLED &&
      o.Queued > 0

    const deleteSending =
      o.Source !== SENDING_SOURCE_ABTEST_WINNER &&
      o.Source !== SENDING_SOURCE_ABTEST_TEST &&
      (o.Status === SENDING_STATUS_QUEUECOMPLETED ||
        (o.Status === SENDING_STATUS_QUEUEFAILED &&
          o.Source !== SENDING_SOURCE_CAMPAIGN) ||
        o.Status === SENDING_STATUS_QUEUECANCELLED)

    //

    const fasciaDiNonDisturbo =
      o.Source !== SENDING_SOURCE_ABTEST_WINNER &&
      o.Source !== SENDING_SOURCE_ABTEST_TEST &&
      canSchedule &&
      o.Queued > 0 &&
      GracePeriod !== 2 &&
      (o.Status === SENDING_STATUS_QUEUECOMPLETED ||
        o.Status === SENDING_STATUS_QUEUEFAILED)

    return {
      idSending: o.Id,
      abortReason: o.AbortReason,
      source: o.Source,
      status: o.Status,
      title: message.Subject,
      idMessage: o.IdMessage,
      idAsyncQueue: o.IdAsyncQueue,
      note: message.Note,
      sender: o.SenderNl,
      isBee: message.IsBee,
      idList: o.IdList,
      isPartial: o.IsPartial,
      isStopped: o.IsStopped,
      sent: o.Sent,
      total: o.Queued,
      progress: o.ToBeQueuedPrecessed / o.ToBeQueued,
      messageType: message.MessageType,
      ...ABTestInfoMap.get(o.Id),
      actions: {
        scheduleNow,
        schedule,
        edit,
        manageCampaign,
        checkup,
        retryCheckQueue,
        cancelCheckQueue,
        previewQueueComplete,
        previewQueueRunning,
        deleteSending,
        fasciaDiNonDisturbo,
        selectedRecipients
      }
    }
  })

  const campaignsMapping = await getCampaignsInfo(Items)

  const withCampaignsData = Items.map(o => {
    const campaignData = campaignsMapping.get(o.idMessage)
    return {
      ...o,
      ...campaignData,
      title: campaignData ? campaignData.campaignName : o.title
    }
  })

  return {
    Items: withCampaignsData
  }
}

export async function fetchPecPlusConfigs() {
  const configs = await bePecPlusGetListOfPecPlusConfigs([], 0, 0)
  const userLists = storeGet(STORE_KEY_USER_LISTS)

  const filteredConfigs = configs.Items.filter(pecConfig =>
    userLists.includes(pecConfig.IdList)
  )
  const lists = await Promise.all(
    filteredConfigs.map(c => BeListApiGetList(c.IdList))
  )

  return filteredConfigs.map(c => {
    const list = lists.find(o => o.IdList === c.IdList)

    return {
      IdList: list.IdList,
      Name: list.Name,
      Status: c.Status
    }
  })
}

export const stopSending = beSendGoStopSending

export const recoverSending = beSendGoRecoverSending

export const exchangeSendingsOrder = beSendGoExchangeOrderReadySending

export async function scheduleNow(idSending) {
  const { IdList } = await beSendGoGetEmailSendingDetails(idSending)
  const { TimeZoneCode } = await BeListApiGetList(IdList)

  return beSendGoSetStandBySendingToReady(idSending, {
    StartDate: new Date().toISOString(),
    TimeZoneInternalCode: TimeZoneCode,
    Source: SENDING_SOURCE_SCHEDULED_NOW
  })
}

export async function retryCheckQueue(idAsyncQueue) {
  const { Id } = await beQueueGetRetryConfiguration(idAsyncQueue)
  return beQueueExecuteConfigurationProcessing(Id)
}

export const cancelCheckQueue = beQueueCancelConfigurationProcessing

export const deleteSending = beSendGoDeleteSending

export async function getSendingSegmentation(idSending) {
  const hasEngagement = evalCondition('co:DELSTATS OR co:ENGAGEMENT')
  const hasSimulation = evalCondition('co:DELTACALCSEGM')

  let {
    IdMessage,
    IdSendStop,
    Groups,
    ExcludeGroups,
    Filtri,
    Queued: queued
  } = await beSendGoGetEmailSendingDetails(idSending)

  if (!Groups) {
    Groups = ''
  }

  const groupsIds = Groups.split(',')
    .filter(o => !!o)
    .map(o => parseInt(o))

  const groupsCalls = groupsIds.map(idGroup => {
    return idGroup !== -1 && idGroup !== 0
      ? beRecipientGetGroupDetails(idGroup)
      : {
          Id: idGroup
        }
  })

  const groups = (await Promise.all(groupsCalls)).map((group, index) => {
    return group
      ? {
          id: group.Id,
          name:
            group.Id !== 0
              ? group.Name
              : getIntl().formatMessage({ id: 'Load.Filters.NoGroupOption' })
        }
      : {
          id: groupsIds[index],
          deleted: true
        }
  })

  if (!ExcludeGroups) {
    ExcludeGroups = ''
  }

  const excludedGroupsIds = ExcludeGroups.split(',')
    .filter(o => !!o)
    .map(o => parseInt(o))

  const excludedGroupsCalls = excludedGroupsIds.map(idGroup =>
    beRecipientGetGroupDetails(idGroup)
  )

  const excludedGroups = (await Promise.all(excludedGroupsCalls)).map(
    (group, index) => {
      return group
        ? {
            id: group.Id,
            name: group.Name
          }
        : {
            id: excludedGroupsIds[index],
            deleted: true
          }
    }
  )

  if (!Filtri) {
    Filtri = ''
  }

  const filtersIds = Filtri.split(',')
    .filter(o => !!o)
    .map(o => parseInt(o))

  const filtersCalls = filtersIds.map(idFilter => beFiltersGetFilter(idFilter))

  const filters = (await Promise.all(filtersCalls))
    .map((filter, index) => {
      return filter
        ? {
            id: filter.Id,
            name: filter.Name,
            type: filter.Type
          }
        : {
            id: filtersIds[index],
            deleted: true
          }
    })
    .filter(({ type }) => {
      return type !== FILTER_TYPE_ENGAGEMENT || hasEngagement
    })

  const anyDeleted = []
    .concat(groups, excludedGroups, filters)
    .some(o => !!o.deleted)

  return {
    idMessage: IdMessage,
    simulationEnabled: hasSimulation && IdSendStop === 0 && !anyDeleted,
    stopped: IdSendStop !== 0,
    queued,
    groups,
    excludedGroups,
    filters
  }
}

export async function simulateSending(
  idSending,
  groups,
  excludedGroups,
  filters
) {
  const { IdList } = await beSendGoGetEmailSendingDetails(idSending)

  const config = {
    IdList,
    IdInvio: 0,
    Action: BEQUEUE_CONFIG_ACTION_MAIL,
    Type: BEQUEUE_CONFIG_TYPE_EVERYBODY,
    FiltersConditionRule: BEQUEUE_CONFIG_FILTER_COND_OR,
    AsyncQueueFilter: filters.map(({ id: IdFilter }) => ({ IdFilter })),
    AsyncQueueGroup: [
      ...groups.map(({ id: IdGroup }) => ({
        IdGroup,
        Action: BEQUEUE_CONFIG_INCLUDE
      })),
      ...excludedGroups.map(({ id: IdGroup }) => ({
        IdGroup,
        Action: BEQUEUE_CONFIG_EXCLUDE
      }))
    ]
  }

  const result = await beQueueSimulateConfigurationProcessing(config)

  return result
}

export async function setSendingImmediate(idSending) {
  return beSendGoSetStandBySendingToReady(idSending, {
    StartDate: null,
    TimeZoneInternalCode: '',
    Source: SENDING_SOURCE_IMMEDIATE
  })
}

export async function setSendingScheduled(
  idSending,
  DateStart,
  TimeZoneInternalCode,
  planningType
) {
  return beSendGoSetStandBySendingToReady(idSending, {
    StartDate: DateStart.toISOString(),
    TimeZoneInternalCode,
    Source: SENDING_SOURCE_SCHEDULED,
    PlanningType: planningType
  })
}

export async function setNoDisturbConfig(idSending, value) {
  const result = beSendGoSetNoDisturbConfig(idSending, value)
  return result
}

export async function updateNoDisturbConfig(idSending, value) {
  const result = beSendGoUpdateNoDisturbConfig(idSending, value)
  return result
}

export async function removeNoDisturbConfig(idSending) {
  const result = beSendGoRemoveNoDisturbConfig(idSending)
  return result
}

export async function getNoDisturbConfig(idSending) {
  const result = beSendGoGetNoDisturbConfig(idSending)

  return result
}

export const getSmartPlanningSuggestedDate = async idSending => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = beSendGoApiGetSmartPlanningSuggestedDate(idList, idSending)

  return result
}
